import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref } from "vue";
const _hoisted_1 = { class: "flex min-h-screen flex-col items-center justify-center gap-4 px-4 py-10 text-center" };
const _hoisted_2 = {
    key: 0,
    class: "rounded-2xl bg-red-50 p-4 text-sm font-medium text-red-700"
};
const _hoisted_3 = {
    key: 1,
    class: "flex flex-col items-center gap-3 text-sm text-eblack-500",
    role: "status"
};
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { createFileDownload } from "@/domains/itinerary/repositories/public-itinerary-review.repository";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FileDownload',
    setup(__props) {
        const route = useRoute();
        const { t } = useI18n();
        const error = ref("");
        function parseHashParams(hash) {
            const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
            return { accessGrant: params.get("access-grant") ?? "" };
        }
        onMounted(async () => {
            const fileId = String(route.params.fileId ?? "");
            const accessGrant = parseHashParams(window.location.hash).accessGrant;
            // The access grant must never persist visibly in the URL bar once read. Preserve
            // history.state (Vue Router stores its own navigation bookkeeping there) rather than nulling
            // it out — see https://router.vuejs.org/guide/migration/#Usage-of-history-state.
            window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
            try {
                const result = await createFileDownload(fileId, accessGrant);
                window.location.replace(result.url);
            }
            catch {
                error.value = t("public_file_download.unavailable");
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("svg", {
                            class: "h-9 w-9 animate-spin text-eorange-500",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true"
                        }, [
                            _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8v8z"
                            })
                        ], -1)),
                        _createElementVNode("p", null, _toDisplayString(_unref(t)("public_file_download.loading")), 1)
                    ]))
            ]));
        };
    }
});
